// src/redux/store.js

import { createStore, applyMiddleware } from 'redux';
import { combineReducers } from 'redux';
import authReducer from './reducers/authReducer';
import { thunk } from 'redux-thunk';

import { configureStore } from '@reduxjs/toolkit';
import { 
  persistStore, 
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // default: localStorage
import doctorDashboardReducer from './reducers/doctor/doctorDashboardReducer';

// Redux Persist config
const persistConfig = {
  key: 'root',
  storage, // Use localStorage (default storage engine)
  whitelist: ['auth', 'doctorDashboard'], // You can whitelist parts of your state to persist
};

// Combine reducers (you can add more reducers if needed)
const rootReducer = combineReducers({
    auth: authReducer,
    doctorDashboard: doctorDashboardReducer
  });

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store with Redux Thunk and Redux Persist
const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

const persistor = persistStore(store);

export { store, persistor };

